import { Clock } from "lucide-react";
import { business } from "../config/business";
import { useLanguage } from "../i18n/LanguageContext";
import { Chapter, Reveal } from "./shared";

const GoogleLogo = () => (
  <svg viewBox="0 0 24 24" className="h-6 w-6" aria-hidden="true">
    <path fill="#4285F4" d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z" />
    <path fill="#34A853" d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z" />
    <path fill="#FBBC05" d="M5.84 14.1c-.22-.66-.35-1.36-.35-2.1s.13-1.44.35-2.1V7.06H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.94l3.66-2.84z" />
    <path fill="#EA4335" d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.06l3.66 2.84c.87-2.6 3.3-4.52 6.16-4.52z" />
  </svg>
);

// Sin reseñas inventadas ni estrellas. Con business.googleReviewsUrl definido se muestra el botón real.
const Reviews = () => {
  const { t } = useLanguage();
  const live = Boolean(business.googleReviewsUrl);

  return (
    <section data-testid="reviews-section" className="relative mx-auto max-w-6xl px-5 sm:px-8 py-20 sm:py-28">
      <Chapter title={t.reviews.title} />
      <Reveal>
        <div className="card-elevated relative flex flex-col items-center gap-5 overflow-hidden rounded-3xl p-10 sm:p-14 text-center">
          {!live && (
            <span className="flex h-14 w-14 items-center justify-center rounded-2xl bg-white shadow-[0_12px_28px_-10px_rgba(0,0,0,0.6)]">
              <GoogleLogo />
            </span>
          )}
          {live ? (
            <a
              data-testid="google-reviews-button"
              href={business.googleReviewsUrl}
              target="_blank"
              rel="noopener noreferrer"
              className="btn rounded-2xl bg-gradient-to-b from-white to-slate-100 px-8 py-4 text-base text-slate-900 shadow-[inset_0_1px_0_rgba(255,255,255,1),0_14px_30px_-10px_rgba(0,0,0,0.6)]"
            >
              <GoogleLogo />
              {t.reviews.button}
            </a>
          ) : (
            <>
              <p data-testid="google-reviews-coming-soon" className="font-heading text-xl sm:text-2xl font-semibold tracking-[-0.02em] text-slate-50">
                {t.reviews.body}
              </p>
              <p className="inline-flex max-w-xl items-start gap-2 text-sm sm:text-base leading-relaxed text-slate-400">
                <Clock className="mt-1 h-4 w-4 shrink-0 text-amber-400" />
                {t.reviews.note}
              </p>
            </>
          )}
        </div>
      </Reveal>
    </section>
  );
};

export default Reviews;
